import SummaryType from "state/selections/Constants/SummaryType";
import CovarianceType from "state/selections/Constants/CovarianceType";
import { isDefined } from "@ls/js-utils";

export default class TrackingErrorDefinition {
  static getDefault = () =>
    new TrackingErrorDefinition({
      covarianceType: CovarianceType.HIST.value,
      factor: "TOTAL",
      summary: SummaryType.ABSOLUTE,
    });

  #covarianceType;
  #factor;
  #summary;

  constructor(props = {}) {
    const { covarianceType, factor, summary } = props;

    this.#covarianceType = covarianceType;
    this.#factor = factor;
    this.#summary = summary;
  }

  copy = () => {
    return {
      covarianceType: this.covarianceType,
      factor: this.factor,
      summary: this.summary,
    };
  };

  get covarianceType() {
    return this.#covarianceType;
  }
  get factor() {
    return this.#factor;
  }
  get summary() {
    return this.#summary;
  }
  get key() {
    return `Tracking Error - ${this.summary}, ${this.covarianceType}, ${this.factor}`;
  }
  get complete() {
    return isDefined(this.covarianceType) && isDefined(this.factor);
  }

  setCovarianceType = (value) =>
    new TrackingErrorDefinition({
      ...this.copy(),
      covarianceType: value,
    });
  setFactor = (value) =>
    new TrackingErrorDefinition({
      ...this.copy(),
      factor: value,
    });
  setSummary = (value) =>
    new TrackingErrorDefinition({
      ...this.copy(),
      summary: value,
    });
}
